var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHighlightAlertIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 43 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .953)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "currentColor",
    width: 43,
    height: 43,
    rx: 21.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#F6F8FA",
    cx: 21.686,
    cy: 21.693,
    rx: 13.134,
    ry: 13.139
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.092 18.905a.99.99 0 0 0-.655-1.018 1.222 1.222 0 0 0-.874 0 .99.99 0 0 0-.66.959v.005c0 .009 0 .018.002.027l.356 3.767a.67.67 0 0 0 .448.65.81.81 0 0 0 .582 0 .67.67 0 0 0 .448-.65l.353-3.74zM22 23.873a.927.927 0 0 0-.643.255.85.85 0 0 0-.267.616c0 .24.102.458.267.616a.927.927 0 0 0 .643.255.927.927 0 0 0 .643-.255.85.85 0 0 0 .267-.616.85.85 0 0 0-.267-.616.927.927 0 0 0-.643-.255zm1.68-9.038 6.124 10.179.002-.001a2.035 2.035 0 0 1 .194.876c0 .478-.163.937-.443 1.309a2.18 2.18 0 0 1-1.148.788.347.347 0 0 1-.124.013L15.782 28a.348.348 0 0 1-.074-.008 2.033 2.033 0 0 1-1.49-1.13c-.2-.412-.267-.89-.182-1.348.034-.182.093-.364.179-.54h-.001a.321.321 0 0 1 .03-.05L20.32 14.84a.312.312 0 0 1 .04-.054c.805-1.046 2.467-1.049 3.283-.012a.31.31 0 0 1 .037.06z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighlightAlertIcon);
export default __webpack_public_path__ + "static/media/highlightAlertIcon.16e59d70f8090b7d8d35abda334b322e.svg";
export { ForwardRef as ReactComponent };